import { render, staticRenderFns } from "./AgreementBadge.vue?vue&type=template&id=43c70dba&scoped=true"
import script from "./AgreementBadge.vue?vue&type=script&lang=js"
export * from "./AgreementBadge.vue?vue&type=script&lang=js"
import style0 from "./AgreementBadge.vue?vue&type=style&index=0&id=43c70dba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c70dba",
  null
  
)

export default component.exports